var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('ol',{staticClass:"register-steps"},_vm._l((_vm.sidebarListLinks),function(sidebarListLink,idx){return _c('li',{key:'sid-link-' + idx,class:{
                'steps-checked': _vm.step > idx + 1,
                'steps-active': _vm.step == idx + 1
            }},[_c('router-link',{attrs:{"to":_vm.getIfRouteNotDisabled(sidebarListLink)}},[_vm._v(_vm._s(sidebarListLink.label))])],1)}),0),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }